export enum SiteStepsEnum {
    SITE_INFORMATION = 0,
    SITE_ADDRESS = 1,
  }

export enum Metrics {
  metricsImperial = "imperial",
  metricsMetric = "metric",
}